export const Mono = ({ children, className = "" }) => (
  <span className={`font-mono uppercase tracking-[0.2em] ${className}`}>{children}</span>
);

export const token = () => localStorage.getItem("mdau_token");
export const money = (v) => (v === "" || v == null || isNaN(v) ? "—" : `$${Number(v).toLocaleString("en-AU", { maximumFractionDigits: 0 })}`);

export const inpCls = "w-full bg-navy-950 border border-gold-500/20 px-3 py-2.5 text-white text-sm focus:outline-none focus:border-gold-500";
export const selCls = inpCls + " cursor-pointer";

export function Field({ label, children }) {
  return (<label className="block"><Mono className="text-white/55 text-[0.5rem] block mb-1.5">{label}</Mono>{children}</label>);
}

export function Section({ title, children }) {
  return (
    <div className="space-y-4">
      <Mono className="text-gold-400/80 text-[0.55rem] block border-b border-gold-500/15 pb-2">{title}</Mono>
      {children}
    </div>
  );
}

export function Toggle({ label, checked, onChange, testid }) {
  return (
    <button type="button" onClick={() => onChange(!checked)} data-testid={testid} className="flex items-center gap-2.5 group">
      <span className={`h-5 w-9 rounded-full transition-colors relative ${checked ? "bg-gold-500" : "bg-navy-800 border border-gold-500/20"}`}>
        <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white transition-all ${checked ? "left-4" : "left-0.5"}`} />
      </span>
      <span className="text-sm text-white/70 group-hover:text-white">{label}</span>
    </button>
  );
}
